import React, { useEffect, useRef } from 'react';

const HeroSection = ({ theme, onInfoClick }) => {
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);

  useEffect(() => {
    // Set page load time for animation timing (exactly like original)
    window.pageLoadTime = Date.now();
    
    // Reset hero animation on page load
    const firstName = firstNameRef.current;
    const lastName = lastNameRef.current;
    
    if (firstName && lastName) {
      // Reset to initial state
      firstName.style.removeProperty('transform');
      firstName.style.removeProperty('opacity');
      lastName.style.removeProperty('transform');
      lastName.style.removeProperty('opacity');
    }
  }, []);

  useEffect(() => {
    // Scroll-based hero animation (exactly like original)
    const handleScroll = () => {
      const heroSection = document.getElementById('hero');
      if (!heroSection) return;

      const scrollY = window.scrollY;
      const heroHeight = heroSection.offsetHeight;
      const heroTop = heroSection.offsetTop;
      
      // Calculate how far we've scrolled through the hero section (0 to 1)
      const scrollProgress = Math.min(Math.max((scrollY - heroTop) / heroHeight, 0), 1);
      
      // Get the name elements
      const firstName = firstNameRef.current;
      const lastName = lastNameRef.current;
      
      if (firstName && lastName) {
        // Check if initial entrance animation is complete (after 2.5 seconds total)
        const timeSinceLoad = Date.now() - (window.pageLoadTime || Date.now());
        const initialAnimationComplete = timeSinceLoad > 2500;
        
        if (initialAnimationComplete) {
          // Handle scroll-based exit animation
          if (scrollProgress > 0) {
            // Move first name further right (continuing its initial direction from left to center)
            const firstNameTransform = scrollProgress * 100; // From 0 to 100vw (right)
            firstName.style.setProperty('transform', `translateX(${firstNameTransform}vw)`, 'important');
            
            // Move last name further left (continuing its initial direction from right to center)
            const lastNameTransform = -(scrollProgress * 100); // From 0 to -100vw (left)
            lastName.style.setProperty('transform', `translateX(${lastNameTransform}vw)`, 'important');
            
            // Fade out opacity as we scroll
            const opacity = 1 - scrollProgress;
            firstName.style.setProperty('opacity', opacity, 'important');
            lastName.style.setProperty('opacity', opacity, 'important');
          } else {
            // When back at the top, reset names to center position
            firstName.style.setProperty('transform', 'translateX(0)', 'important');
            lastName.style.setProperty('transform', 'translateX(0)', 'important');
            firstName.style.setProperty('opacity', '1', 'important');
            lastName.style.setProperty('opacity', '1', 'important');
          }
        }
      }
      
      // Info icon stays visible (removed scroll-based opacity changes)
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleInfoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Scroll to top before transitioning
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    if (onInfoClick) {
      onInfoClick();
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <div className="name-container">
          <h1 className="first-name" ref={firstNameRef}>Namra</h1>
          <h1 className="last-name" ref={lastNameRef}>Shah</h1>
        </div>
      </div>
      
      {/* Info Icon */}
      <div className="info-icon" id="info-icon" onClick={handleInfoClick}>
        <span className="info-text">i</span>
      </div>
    </section>
  );
};

export default HeroSection;
